module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    ref: "fileinput",
    staticClass: "inputfile",
    attrs: {
      "id": "file",
      "type": "file",
      "text": "Select SVG Files",
      "multiple": "",
      "placeholder": "Email"
    },
    on: {
      "change": _vm.onselected
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, _vm._l((_vm.pendingUploadFiles), function(f, i) {
    return _c('div', {
      staticClass: "column is-3"
    }, [(f.file) ? _c('div', {
      staticClass: "box content"
    }, [(!f.valid) ? _c('div', {
      staticClass: "notification is-danger"
    }, [_vm._v("\n        File " + _vm._s(f.file.name) + " is not valid\n      ")]) : _vm._e(), _vm._v(" "), (f.valid) ? _c('table', {
      staticClass: "table"
    }, [_c('tr', [_vm._m(1, true), _vm._v(" "), (_vm.assetUniqueNames.indexOf(f.unique_name) >= 0) ? _c('td', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "input is-danger",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": f.unique_name
      },
      on: {
        "input": function($event) {
          _vm.updateName(f, $event)
        }
      }
    }), _vm._v(" "), _vm._m(2, true)]) : _c('td', {
      staticClass: "control "
    }, [_c('input', {
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": f.unique_name
      },
      on: {
        "input": function($event) {
          _vm.updateName(f, $event)
        }
      }
    })])]), _vm._v(" "), _c('tr', [_vm._m(3, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.file.name))])]), _vm._v(" "), _c('tr', [_vm._m(4, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(f.file.size))])]), _vm._v(" "), _c('tr', [_vm._m(5, true), _vm._v(" "), _c('td', [(f.file.lastModifiedDate) ? _c('span', [_vm._v(_vm._s(f.file.lastModifiedDate.toLocaleTimeString()) + " - " + _vm._s(f.file.lastModifiedDate.toDateString()))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "has-text-centered"
    }, [_c('button', {
      staticClass: "button is-dark is-outlined",
      on: {
        "click": function($event) {
          _vm.removePendingFile(f)
        }
      }
    }, [_vm._v("REMOVE")])])]) : _vm._e()])
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingUploadFiles.length > 0),
      expression: "pendingUploadFiles.length > 0"
    }],
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.loadPendingFiles
    }
  }, [_vm._v("\n      Add Selected Resources\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "button",
    attrs: {
      "for": "file"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  })]), _c('span', [_vm._v("Load SVG File(s)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    staticClass: "label has-text-right"
  }, [_vm._v("Unique Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help is-danger"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  })]), _vm._v(" Name is in use already")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    staticClass: "label has-text-right"
  }, [_vm._v("File Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    staticClass: "label has-text-right"
  }, [_vm._v("size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('label', {
    staticClass: "label has-text-right"
  }, [_vm._v("last modified")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1883ee89","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileloader.vue
// module id = 60
// module chunks = 4